<div class="card-container card-container--{{ colorClass }}">
    <div class="card__social-network">
        <img class="card__social-network-icon" src="{{ iconLink }}" alt="">
        <p class="card__social-network-username">{{ username }}</p>
    </div>
    <div class="card__followers">
        <p class="card__followers-number">{{ followersNumber }}</p>
        <p class="card__followers-title">FOLLOWERS</p>
    </div>
    <div class="card__status">
        <img class="card__status-icon" src="{{ statusIconLink }}" alt="">
        <p class="card__status-title card__status-title--{{ statusColor }}">{{ followersNumberToday }} Today</p>
    </div>
</div>